import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Numeral from '../numeral';
import Pluralize from 'react-pluralize';
import Voucher from '../voucher';
import CoffeeSummary from './CoffeeSummary';
import ProductsSummary from './productsSummary';
import { showShippingModal } from '../../reducers/shippingModal';

import {
  StyledSummary,
  StyledSummaryItem,
  StyledFreeShipping,
  StyledSummaryItemLink
} from './style';

const SummaryItem = ({ editUrl, children, className }) => {
  return(
    <StyledSummaryItem className={className}>
      <div>{children}</div>

      {editUrl ? <Link to={editUrl} className="edit-link">Editar</Link> : '' }
    </StyledSummaryItem>
  )
}

const Summary = () => {
  const dispatch = useDispatch();

  const brewingMethods = useSelector((state) => state.brewingMethods);
  const subscription = useSelector((state) => state.subscription);
  const steps = useSelector((state) => state.steps);
  const voucher = useSelector((state) => state.voucher);

  const handleShippingModalClick = () => {
    dispatch(showShippingModal());
  }

  let brewingMethodName;

  if(brewingMethods){
    let brewingMethod = brewingMethods.find((brewingMethod) => {
      return brewingMethod.id === subscription.brewingMethod;
    });

    if(brewingMethod){
      brewingMethodName = brewingMethod.name;
    }
  }

  return (
    <StyledSummary>
      <div className="title">
        Resumo da sua assinatura
      </div>

      <SummaryItem editUrl={steps[2].complete ? '/plano-gateway' : null}>
        Quantidade: <strong>
          <Pluralize singular="pacote" count={subscription.quantity} />
          {subscription.orderType === 2 ? <><Pluralize singular=" diferente" showCount={false} count={subscription.quantity} /> por envio</> : ''}
        </strong>

        <CoffeeSummary coffees={subscription.coffees} />
      </SummaryItem>

      {Object.keys(subscription.products).length > 0 && <SummaryItem editUrl={steps[2].complete ? '/plano-gateway' : null}>
        Produtos: <ProductsSummary />
      </SummaryItem>}

      <SummaryItem editUrl={steps[4].complete ? '/metodo-de-preparo' : null}>
        Grãos ou Moído: {subscription.brewingMethod >= 0 ? <strong>{subscription.ground === 'true' ? `Moído para ${brewingMethodName}` : 'Em grãos'}</strong> : 'A definir'}
      </SummaryItem>

      <SummaryItem editUrl={steps[3].complete ? '/frequencia-gateway' : null}>
        Frequência: {subscription.frequency ? <strong>A cada {subscription.frequency} dias</strong> : 'A definir'}
      </SummaryItem>

      <SummaryItem>
        Subtotal: <strong><Numeral value={subscription.coffeesPrice} format="$ 0,0.00" /></strong>
      </SummaryItem>

      {steps[5].complete && <SummaryItem>
        Cupom: <Voucher />

        {voucher && <div className="hint">
          {voucher.description}
        </div>}
      </SummaryItem>}

      {subscription.zipcode && <SummaryItem editUrl={steps[5].complete ? '/entrega' : null}>
        Frete: <strong>
          {subscription.shippingPrice === 0 ? <StyledFreeShipping>GRÁTIS</StyledFreeShipping> : <Numeral value={subscription.shippingPrice} format="$ 0,0.00" />}
        </strong> <span>
          (<Pluralize singular="dia útil" plural="dias úteis" count={subscription.deliveryTime} />)
        </span>

        <StyledSummaryItemLink onClick={handleShippingModalClick}>
          Entenda seu prazo
        </StyledSummaryItemLink>
      </SummaryItem>}

      {subscription.zipcode && <SummaryItem className="total">
        Total: <strong><Numeral value={subscription.totalPrice} format="$ 0,0.00" /></strong>
      </SummaryItem>}
    </StyledSummary>
  )
}

export default Summary;
